module.exports = __webpack_public_path__ + "static/media/logo.a63ccf08.png";